// extracted by mini-css-extract-plugin
export default {"produtos":"Produtos_produtos__Br6jn","produtoCSS1":"Produtos_produtoCSS1__lOCf9"};